"use strict";

exports.__esModule = true;
exports.DexPriceProvider = void 0;
var _rxjs = require("rxjs");
class DexPriceProvider {
  constructor(liquidity) {
    this.liquidity = void 0;
    this.liquidity = liquidity;
  }
  subscribe(currency) {
    return this.liquidity.subscribeDexPrice(currency);
  }
  async query(currency) {
    return (0, _rxjs.firstValueFrom)(this.subscribe(currency));
  }
}
exports.DexPriceProvider = DexPriceProvider;